import React, { ReactNode } from 'react';
import { Grid2 as Grid, Box } from '@mui/material';
import { useFormikContext } from 'formik';
import UserDetails from './UserDetails';

const UserEditorBase = ({ children }: { children: ReactNode }) => {
  const formik = useFormikContext<{
    firstName: string;
    lastName: string;
    profileImageUrl: string;
    designation: string;
  }>();

  const { values, setFieldValue } = formik;

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 3, lg: 3 }}>
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <UserDetails
            firstName={values.firstName}
            lastName={values.lastName}
            profileImageUrl={values.profileImageUrl}
            designation={values.designation}
            onImageUpload={() =>
              setFieldValue(
                'profileImageUrl',
                'https://www.keckmedicine.org/wp-content/uploads/2018/03/Four-friends-toast-before-consuming-alcoholic-drinks..jpg'
              )
            }
            onImageRemove={() => setFieldValue('profileImageUrl', '')}
          />
        </Box>
      </Grid>
      <Grid size={{ xs: 12, md: 9, lg: 6 }}>{children}</Grid>
    </Grid>
  );
};

export default UserEditorBase;
